import { Button, Checkbox, Container, FormControlLabel, Typography, Box } from '@mui/material'
import { useState } from 'react'
import { BottomSheetContainer } from './MuiComponents'
import { t } from '~/utils/narration'

export default function Consent({ onContinue }: any) {
  const [checked, setChecked] = useState(false)
  return (
    <>
      <Typography variant="h5" fontWeight="bold" sx={{ pb: 2, pt: 4 }} gutterBottom>
        {t({ en: 'Your consent is needed', hi: 'आपकी सहमति आवश्यक है' })}
      </Typography>

      <Typography variant="body1">
        {t({
          en: 'To verify your identity, Kriyam.ai needs your current geolocation, selfie photo, and a photo of you holding your Aadhaar card (masked number). We use this info securely for account protection.',
          hi: 'आपकी पहचान वेरिफ़ाई करने के लिए, Kriyam.ai को आपकी वर्तमान भू-स्थिति, सेल्फ़ी फ़ोटो, और आधार कार्ड (मास्क किए गए नंबर सहित) पकड़े हुए आपकी फ़ोटो चाहिए। हम इस जानकारी का उपयोग आपके खाते की सुरक्षा के लिए सुरक्षित रूप से करते हैं।',
        })}
        <br />
        {t({
          en: 'By tapping "Continue," you acknowledge that you have read and understood this declaration and consent and you confirm ownership and consent to verification and data use as explained in the Privacy Policy of the Verifier. You have rights to access/update info and withdraw consent with the Verifier at a later stage.',
          hi: '"आगे बढ़ें" पर टैप करके, आप स्वीकार करते हैं कि आपने इस घोषणा और सहमति को पढ़ और समझ लिया है तथा आप वेरिफ़ायर की गोपनीयता नीति में बताए अनुसार स्वामित्व की पुष्टि करते हैं और वेरिफ़िकेशन एवं डेटा उपयोग के लिए सहमति देते हैं। आपको बाद में जानकारी देखने/अपडेट करने और वेरिफ़ायर से सहमति वापस लेने का अधिकार है।',
        })}
      </Typography>
      <BottomSheetContainer maxWidth="sm">
        <Box sx={{}}>
          <Typography variant='h6' fontWeight={600} py={1} borderBottom="2px solid rgba(0,0,0,0.06)">{t({ en: 'Give your approval', hi: 'अपनी स्वीकृति दें' })}</Typography>
        </Box>
        <Box sx={{ px: 2, py: 1.5 }}>
          <FormControlLabel
            sx={{ float: 'left', mb: 1 }}
            control={<Checkbox checked={checked} onChange={(e) => setChecked(e.target.checked)} />}
            label={t({ en: 'I agree to the terms and data usage policy', hi: 'मैं नियमों और डेटा उपयोग नीति से सहमत हूँ' })}
          />
          <Button
            fullWidth
            disabled={!checked}
            onClick={onContinue}
            size="large"
            sx={{ py: 1.5 }}
          >
            {t({ en: 'Continue', hi: 'आगे बढ़ें' })}
          </Button>
        </Box>
      </BottomSheetContainer>


      {/* <Container maxWidth="sm" sx={{ position: 'fixed', bottom: 0, left: 0, right: 0 }}>
        <FormControlLabel
          sx={{ float: 'left' }}
          control={<Checkbox checked={checked} onChange={(e) => setChecked(e.target.checked)} />}
          label="I consent to terms and data use."
        />
        <Button
          fullWidth
          disabled={!checked}
          onClick={onContinue}
          size="large"
          sx={{ my: 3, py: 1.5 }}
        >
          Continue
        </Button>
      </Container> */}
    </>
  )
}
